<div class="grid" *ngIf="{ currentUser: CurrentUser$ | async, head: MessageHead$ | async } as data">
    <div class="col-12 xl:col-3">
        <mat-card class="mat-elevation-z0" *ngIf="ActiveUsers$ | async as Users">
            <mat-card-title>
                <div class="flex align-items-center justify-content-between">
                    <div>Message Center</div>
                    <button mat-icon-button
                            [matMenuTriggerFor]="sortMenu"
                            [title]="'txMessageCenter.sort' | translate">
                        <fa-icon icon="sort"></fa-icon>
                    </button>
                    <mat-menu #sortMenu="matMenu">
                        <button mat-menu-item (click)="setSortMode('recent')">
                            <fa-icon icon="check" class="mr-2" [class.invisible]="(SortMode$ | async) !== 'recent'"></fa-icon>
                            {{ 'txMessageCenter.sort_recent' | translate }}
                        </button>
                        <button mat-menu-item (click)="setSortMode('name')">
                            <fa-icon icon="check" class="mr-2" [class.invisible]="(SortMode$ | async) !== 'name'"></fa-icon>
                            {{ 'txMessageCenter.sort_name' | translate }}
                        </button>
                    </mat-menu>
                </div>
            </mat-card-title>
            <tx-list [items]="Users"
                     [labelField]="getLabel"
                     [idField]="'persnr'"
                     [searchField]="'firstname,lastname'"
                     [showNew]="false"
                     [badges]="getBadges(data.head)"
                     routerLinkBase="personaloffice/messages"
                     (selectedItem)="Employee = $event ? $event.lastname + ', ' + $event.firstname : ''"
            ></tx-list>
        </mat-card>
    </div>
    <div class="col-12 xl:col-9" *ngIf="UserMessages$ | async as UserMessages">
        <section class="widget">
            <div>
                <div style="height: 82vh;">
                    <tx-chat
                            #chat
                            [height]="getAvailableHeight() - (AnswerMessage ? 58 : 0)"
                            [is_office]="true"
                            [Messages]="UserMessages"
                            [(WithArchived)]="WithArchived"
                            [Title]="Employee"
                            [(AnswerMessage)]="AnswerMessage"
                            (refresh)="refresh()"
                            (send)="sendMessage($event.message, $event.answer)"
                            (archive)="archiveMessage($event.message, $event.remove)"
                            (unread)="markMessageUnread($event)"
                    ></tx-chat>
                </div>
            </div>
        </section>
    </div>
</div>
